import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

export default function() {
  const sections = document.querySelectorAll('.vision-section')

  sections.forEach(section => {
    ScrollTrigger.batch(section.querySelectorAll('.vision-item'), {
      onEnter: batch => {
        // Titles array
        const titles = batch.map(item =>
          item.querySelectorAll('.vision-item__title')
        )
        // Images array
        const imgs = batch.map(item =>
          item.querySelectorAll('.vision-item__img')
        )
        // Text array
        const text = batch.map(item =>
          item.querySelectorAll('.vision-item__text')
        )

        gsap
          .timeline()
          .to(batch, {
            opacity: 1,
            y: 0,
            stagger: 0.25,
          })
          .to(
            imgs,
            {
              opacity: 1,
              scale: 1,
              duration: 1,
              stagger: 0.25,
            },
            '<'
          )
          .to(
            titles,
            {
              transform: 'none',
              opacity: 1,
              duration: 0.6,
              stagger: 0.25,
            },
            '<0.2'
          )
          .to(
            text,
            {
              transform: 'none',
              opacity: 1,
              duration: 0.6,
              stagger: 0.25,
            },
            '<0.1'
          )
      },
      start: 'top bottom-=30%',
      end: 'top bottom-=30%',
      once: true,
    })
  })
}
